<template>
  <div v-editable="blok && !blok.isGlobal">
    <h3
      v-if="linkList.title"
      class="title mb-6 text-xl"
      :class="textColorClass(blok.titleVariant, blok.bgVariant, 'text-darker')"
    >
      {{ linkList.title }}
    </h3>
    <ul class="flex flex-col items-start justify-start space-y-4">
      <li v-for="link in linkList.links" :key="link._uid" class="">
        <component
          :is="link.component"
          :item="link"
          :blok="blok"
          :context="context"
          :link-class="textColorClass(blok.linkTextColor, blok.bgVariant)"
        />
      </li>
    </ul>
  </div>
</template>

<script setup>
import CallToActionLink from './CallToActionLink.vue'
import CallToActionButton from './CallToActionButton.vue'
import { useColorPalette } from '../composables/colorPalette'

defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
  linkList: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass } = useColorPalette()

// All of these components can be added dynamically
defineOptions({
  components: {
    CallToActionButton,
    CallToActionLink,
  },
})
</script>
